import React, { FC, useState } from "react";
import { Button } from "primereact/button";
import { CareServicesSection } from "../../../../models/manageWebSite";
import EditModal from "./EditModal";

interface Props {
  data: CareServicesSection | null;
  flag: boolean;
  setFlag: (flag: boolean) => void;
  homeId: string | null;
}

const Section10: FC<Props> = ({ data, flag, setFlag, homeId }) => {
  const [openModal, setOpenModal] = useState(false);

  return (
    <div style={{ width: "100%", background: "linear-gradient(180deg, #eef8ff 0%, #f8fafc 100%)", padding: "3rem 1.25rem" }}>
      <div style={{ maxWidth: "1180px", margin: "0 auto" }}>
        <div className="flex flex-wrap align-items-center justify-content-between gap-3 mb-4">
          <div>
            <div style={{ color: "#185da2", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.12em", fontSize: "0.8rem" }}>Optional Page</div>
            <div style={{ color: "#0f172a", fontSize: "2rem", fontWeight: 800, marginTop: "0.65rem" }}>Care Services</div>
            <div style={{ color: "#64748b", marginTop: "0.65rem", lineHeight: 1.7, maxWidth: "760px" }}>
              Add a dedicated page for specialized care, daily life, meals, activities, and the care team behind the home.
            </div>
          </div>
          <Button label="Edit Care Services" severity="warning" className="website-section-action-button" onClick={() => setOpenModal(true)} />
        </div>

        <div className="grid">
          {[
            { title: "Specialized care", items: data?.specializedCare, bg: "#f8fbff", border: "#dbe7f3", color: "#185da2" },
            { title: "Meals and nutrition", items: data?.mealsAndNutrition, bg: "#fffaf3", border: "#f0dcc2", color: "#b45309" },
            { title: "Daily life", items: data?.dailyLifeHighlights, bg: "#f8fafc", border: "#e2e8f0", color: "#0f172a" },
            { title: "Care team", items: data?.careTeam, bg: "#ffffff", border: "#dbe7f3", color: "#185da2" },
          ].map((card) => (
            <div className="col-12 md:col-6" key={card.title}>
              <div style={{ background: card.bg, border: `1px solid ${card.border}`, borderRadius: "24px", padding: "1.2rem", height: "100%", boxShadow: "0 16px 32px rgba(15,61,99,0.06)" }}>
                <div style={{ color: card.color, fontWeight: 800, textTransform: "uppercase", fontSize: "0.8rem", letterSpacing: "0.1em" }}>{card.title}</div>
                <ul style={{ paddingLeft: "1rem", margin: "0.9rem 0 0", lineHeight: 1.85, color: "#475569" }}>
                  {(card.items || []).map((item, index) => <li key={`${item}-${index}`}>{item}</li>)}
                </ul>
              </div>
            </div>
          ))}
        </div>
      </div>
      <EditModal isOpen={openModal} toggleModal={setOpenModal} flag={flag} setFlag={setFlag} data={data} homeId={homeId} />
    </div>
  );
};

export default Section10;
